import { render, staticRenderFns } from "./SavBreadcrumbs.vue?vue&type=template&id=40463a92&"
import script from "./SavBreadcrumbs.vue?vue&type=script&lang=js&"
export * from "./SavBreadcrumbs.vue?vue&type=script&lang=js&"
import style0 from "./SavBreadcrumbs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
installComponents(component, {VBreadcrumbs})
